<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="border rounded p-2 mb-2">
    <validation-observer ref="loginValidation">
      <b-form
        class="auth-login-form mt-2"
        @submit.prevent
        enctype="multipart/form-data"
      >
        <h5 class="mb-2">Featured Text One</h5>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <!-- email -->
                <b-form-group label="Title" label-for="title">
                  <validation-provider
                    #default="{ errors }"
                    name="title"
                    rules="required"
                  >
                    <b-form-input
                      id="title"
                      v-model="form.title"
                      :state="errors.length > 0 ? false : null"
                      name="title"
                      placeholder="Enter Your Title"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
              <div class="col-md-12">
                <!-- email -->
                <b-form-group label="Description" label-for="description">
                  <validation-provider
                    #default="{ errors }"
                    name="description"
                    rules="required"
                  >
                    <b-form-textarea
                      id="description"
                      v-model="form.description"
                      :state="errors.length > 0 ? false : null"
                      name="description"
                      placeholder="Enter Your Description"
                      rows="4"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="border rounded p-2 mb-2">
              <h4 class="mb-1">Image Setting</h4>

              <b-media
                no-body
                vertical-align="center"
                class="flex-column flex-md-row"
              >
                <b-media-aside>
                  <b-img
                    :src="featured_text_one_image"
                    height="174"
                    width="160"
                    class="rounded mr-2 mb-1 mb-md-0"
                  />
                </b-media-aside>
                <b-media-body>
                  <b-form-group
                    label="Image"
                    label-for="featured_text_one_image"
                  >
                    <b-form-file
                      id="featured_text_one_image"
                      accept=".jpg, .png, .gif"
                      @change="loadImage($event)"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                    />
                  </b-form-group>
                </b-media-body>
              </b-media>
            </div>
          </div>
        </div>
        <!-- submit buttons -->
        <b-button type="submit" variant="primary" @click="validationForm">
          Update
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BMediaBody,
  BMediaAside,
  BMedia,
  BFormFile,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  data() {
    return {
      form: {
        type: 1,
        title: "",
        description: "",
        featured_text_one_image: null,
      },
      featured_text_one_image: null,
      required,
      email,
    };
  },
  mounted() {
    this.getBanner();
  },
  methods: {
    async getBanner() {
      const featured_text = await this.callApi(
        "get",
        "/app/featured/text/show/1"
      );
      if (featured_text.status == 200) {
        this.form.title = featured_text.data.featured_text.title;
        this.form.description = featured_text.data.featured_text.description;
        this.featured_text_one_image =
          this.$store.state.base_url + featured_text.data.featured_text.image;
      }
    },

    loadImage(e) {
      this.form.featured_text_one_image = e.target.files[0];
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.featured_text_one_image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    Update() {
      const fd = new FormData();
      if (this.form.featured_text_one_image) {
        fd.append(
          "featured_text_one_image",
          this.form.featured_text_one_image,
          this.form.featured_text_one_image.name
        );
      }
      fd.append("title", this.form.title);
      fd.append("description", this.form.description);

      axios
        .post("/app/featured/text/update/1", fd)
        .then((res) => {
          this.getBanner();
          this.s(res.data.message);
        })
        .catch((e) => {
          if (e.response.status === 422) {
            if (e.response.data.errors.super_title)
              this.e(e.response.data.errors.super_title[0]);
            if (e.response.data.errors.title)
              this.e(e.response.data.errors.title[0]);
            if (e.response.data.errors.description)
              this.e(e.response.data.errors.description[0]);
            if (e.response.data.errors.btn_1)
              this.e(e.response.data.errors.btn_1[0]);
            if (e.response.data.errors.btn_link_1)
              this.e(e.response.data.errors.btn_link_1[0]);
            if (e.response.data.errors.btn_2)
              this.e(e.response.data.errors.btn_2[0]);
            if (e.response.data.errors.btn_link_2)
              this.e(e.response.data.errors.btn_link_2[0]);
            if (e.response.data.errors.featured_text_one_image)
              this.e(e.response.data.errors.featured_text_one_image[0]);
          }
        });
    },
    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.Update();
        }
      });
    },
  },
  components: {
    BMedia,
    BFormFile,
    BFormTextarea,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BMediaAside,
    BMediaBody,
  },
};
</script>

<style></style>
